import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NoPaymentCardProps as Props } from './types';

export const NoPaymentCard = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('NoOption', className)}
      sx={SX.root}
      xs={12}
    >
      <Stack
        alignItems="center"
        sx={SX.noDataContent}
        gap={3}
        justifyContent="center"
      >
        <Box sx={SX.emptyIconBox}>
          <Stack sx={SX.emptyIconWrapper}>
            <Icon name="credit-card-outlined" sxx={SX.emptyIcon} size={36} />
          </Stack>
        </Box>

        <Box sx={SX.noDataTitleBox}>
          <Box sx={SX.noDataTitleBox1} />
          <Box sx={SX.noDataTitleBox2} />
          <Card variant="outlined" sx={SX.noDataTitleWrapper}>
            <Typography
              variant="body3"
              fontWeight={500}
              color="grey.500"
              margin="auto"
            >
              No Payment Method
            </Typography>
          </Card>
        </Box>
      </Stack>
    </Styled.Wrapper>
  );
});

NoPaymentCard.displayName = 'NoPaymentCard';
